import React from 'react'
import { View, TouchableOpacity } from 'react-native'
// import CircleSnail from 'react-native-progress/CircleSnail'
import Icon from 'react-native-vector-icons/Feather'
import { DateTime } from 'luxon'
import tw from 'tailwind-rn'

import styles from './styles'
// import * as colors from '../../config/colors'
// import { HGMap } from '../../components/HGMap'
import { HGText } from '../../components/HGUI'
import { NewsItemType } from '../../config/types'

type Props = {
  newsItem: NewsItemType
  onNewsItemPress: (itemId: string) => void
}

const NewsListItem = (props: Props) => {
  const { newsItem, onNewsItemPress } = props
  const { title, id, date } = newsItem

  const formattedDate = DateTime.fromISO(date)
    // .setLocale('de')
    .toFormat('dd.LL.yyyy')

  return (
    <View style={tw('mb-3')}>
      <TouchableOpacity
        onPress={() => onNewsItemPress(id)}
        style={styles.listItemInner}
      >
        <View style={styles.listItemTextContainer}>
          <HGText style={styles.newsDateText}>{formattedDate}</HGText>

          <HGText
            style={styles.newsTitleText}
            ellipsizeMode="tail"
            numberOfLines={1}
          >
            {title}
          </HGText>

          {/* <ContentBlock 
            content={title} 
            stylesheet={newsStylesheet} 
            style={ styles.contentContainer }
          /> */}

          {/* <ContentBlock content={teaser} stylesheet={newsStylesheet} /> */}
        </View>

        <View style={styles.listItemIconContainer}>
          <Icon name="chevron-right" size={40} style={styles.listItemIcon} />
        </View>
      </TouchableOpacity>
    </View>
  )
}

export default NewsListItem
